import type { Mission } from "../mission/mission";
import type { MissionSnapshot } from "../mission/objectives";

const STATUS_ICONS: Record<string, string> = {
  pending: "◌",
  success: "●",
  fail: "✕",
  active: "◌",
};

export class MissionHud {
  private readonly el: HTMLElement;
  private lastHtml: string | null = null;

  constructor() {
    const el = document.querySelector("[data-slot='mission']") as HTMLElement | null;
    if (!el) throw new Error("Missing HUD mission slot");
    this.el = el;
    this.el.style.lineHeight = "1.8";
  }

  update(mission: Mission, snap: MissionSnapshot): void {
    this.setHtml(this.buildHtml(mission, snap));
  }

  private buildHtml(mission: Mission, snap: MissionSnapshot): string {
    const phase = mission.currentPhase;

    if (phase === "intro") {
      return `<span style="opacity:0.5;font-size:11px">MISSION</span><br><span style="font-size:13px">${mission.name}</span>`;
    }

    if (phase === "success" || phase === "fail") {
      // Debrief overlay handles end state — clear this slot
      return "";
    }

    const statuses = mission.objectiveStatuses(snap);
    const lines = statuses
      .map(({ label, status }) => {
        const icon = STATUS_ICONS[status] ?? "◌";
        const dim = status === "active" ? " opacity:0.6;" : "";
        return `<span style="font-size:11px;${dim}">${icon} ${label}</span>`;
      })
      .join("<br>");

    return `<span style="opacity:0.5;font-size:10px">${mission.name}</span><br>${lines}`;
  }

  // Objective lines change rarely — skip the per-frame DOM write otherwise.
  private setHtml(html: string): void {
    if (html === this.lastHtml) return;
    this.lastHtml = html;
    this.el.innerHTML = html;
  }
}
